
export const reloadConf = {
    currentBounds: null,
    isRequestStart: false,
    reloadInterval: 0,
    nextStepInterval: 500
  }